const methods = [
  'ACH',
  'OTHER',
  'DEBITCARD',
  'CREDITCARD',
  'PREPAIDCARD',
  'ACCOUNTCREDIT',
  'RECONCILIATION',
];

const statuses = [
  'NONE',
  'FAIL',
  'PREAUTH',
  'DISPUTED',
  'COMPLETE',
  'REFUNDED',
  'INPROGRESS',
  'PREAUTHREFUNDED',
];

export { methods, statuses };
